import { render, staticRenderFns } from "./BillingCarrierChargeTypeBadge.vue?vue&type=template&id=708e92b4"
import script from "./BillingCarrierChargeTypeBadge.vue?vue&type=script&lang=js"
export * from "./BillingCarrierChargeTypeBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports